import gql from 'graphql-tag';
import { evaluationFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const updateEvaluationMutation = gql`
  mutation UpdateEvaluation($id: ID!, $input: UpdateEvaluationInput!) {
    updateEvaluation(id: $id, input: $input) {
      ...AdminSanityDocumentFields
      ...AdminEvaluationFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${evaluationFieldsFragment}
`;